import { AppIdFromName, AppNameFromID } from '../services/apps';

export function updateStorage(application, category, name, value) {
    var storageContent
    if (localStorage.getItem(`${application}`)) {
        storageContent = JSON.parse(localStorage.getItem(`${application}`));
    } else {
        storageContent = {};
    }

    // if (storageContent[category] === undefined) {
    //     storageContent[category] = {};
    // }
    if (storageContent[name] === undefined) {
        storageContent[name] = {};
    }

    storageContent[name] = value;
    localStorage.setItem(`${application}`, JSON.stringify(storageContent));
}

export function getDefaultValue(application, category, name) {
    if (localStorage.getItem(`${application}`)) {
        const storageContent = JSON.parse(localStorage.getItem(`${application}`));
        if (storageContent[name] !== undefined) {
            return storageContent[name];
        }
    }
    return null;
}

export function getFilterPostParams(application) {
    const app = AppNameFromID()[application];
    if (localStorage.getItem(`${app}`)) {
        return JSON.parse(localStorage.getItem(`${app}`));
    }
    return null;
}

export function getFilterQueryParams(query) {
    if (localStorage.getItem(`${query}`)) {
        return JSON.parse(localStorage.getItem(`${query}`));
    }
    return null;
}

export function clearStorage() {
    for (const [key, value] of Object.entries(AppIdFromName())) {
        localStorage.removeItem(`${key}`);
    }
    localStorage.removeItem('active_app');
    localStorage.removeItem('allowed_apps');
}